import { atom } from '@exodus/headless-ui';
const exchangeErrorAtom = atom(null);
export default exchangeErrorAtom;
